import React from 'react';
import GOTYSection from '../Components/GOTYSection';

const GOTY = () => {
  return (
    <div className="app-container">
      <GOTYSection />
    </div>
  )
}

export default GOTY
